export const mapModule = {
  state: {
    stores: [],
  },
  mutations: {
    setStores(state, payload){
      state.stores = payload;
    },
    updateStore(state, payload){
      state.stores.forEach((stateStore, index)=>{
        if(stateStore.uid === payload.uid){
          state.stores[index] = payload;
        }
      })
    },
  },
  getters: {
    stores: state => state.stores
  },
};
